import React, { FC } from 'react';
import { Skeleton } from '@cubeyou-team/hx-react-components';

import translations from 'src/lang';
import QueryBuilderActions from 'src/components/QueryBuilder/components/QueryBuilderActions';
import ConversationBuilderActions from 'src/components/QueryBuilder/components/ConversationBuilderActions';

interface HeaderActionsProps {
  isQueryLoading: boolean;
  isConversation: boolean;
  isQueryValid: boolean;
  onRequestCreateAudience: (app: string) => void;
}

export const HeaderActions: FC<HeaderActionsProps> = ({
  isQueryLoading,
  isConversation,
  isQueryValid,
  onRequestCreateAudience,
}) => {
  if (isQueryLoading) {
    return (
      <Skeleton speed={2} width={300} height={24} viewBox="0 0 500 24">
        <rect x="40" y="3" rx="4" ry="4" width="400" height="18" />
      </Skeleton>
    );
  }

  if (!isConversation) {
    return (
      <QueryBuilderActions
        isQueryValid={isQueryValid}
        isQueryLoading={isQueryLoading}
        onRequestCreateAudience={onRequestCreateAudience}
        runButtonLabel={translations['en-US'].QUERY_BUILDER.runButton.default}
      />
    );
  }

  return (
    <ConversationBuilderActions
      runButtonLabel={
        translations['en-US'].QUERY_BUILDER.runButton.conversation
      }
      isQueryValid={isQueryValid}
    />
  );
};
